<!-- @format -->

<inquiry-tag>

<h2 class="ui header">お問い合わせ</h2>
<div class="ui hidden divider"></div>
<div class="ui breadcrumb">
  <a href="/menu" class="section">ホーム</a>
  <div class="divider"> / </div>
  <div class="active section">お問い合わせ</div>
</div>
<div class="ui segment basic">
<iframe src="https://id.biz-samurai.com/i/mail-sender/18" style="width: 100%; height: 1300px;border: 0px"></iframe>
</div>
<script>
  import faqTag from '@tags/parts/editech-hub-faq.riot';
  export default {
    components: {
      "faq-content-tag": faqTag
    }
  }
</script>
</inquiry-tag>
